export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="app-footer"
      className="border-t border-neutral-200 bg-white mt-12"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center">
        <p className="text-xs text-neutral-500 tracking-wide">
          © {year} <span className="text-[#E30613] font-semibold">FISK</span> — Unidade Sacomã (SP). Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
